import styled, { css } from 'styled-components';
import { Body, Overline } from 'components/Typography';
import addAlpha from 'utils/addAlpha';
import { FiArrowDown, FiArrowUp } from 'react-icons/fi';
import { ComponentProps } from './types';

// TODO: TFR-44 move to container group or do not export
export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 1rem;
  padding: 1.5rem 2rem;
`;

// TODO: TFR-45:Title make unique name or do not export
export const Title = styled(Overline)`
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.6)};
  letter-spacing: 0.1em;
  font-size: 0.8125rem;
  font-weight: 600;
  display: block;
  margin-bottom: 1rem;
`;

// TODO: TFR-45:DataContainer make unique name or do not export
export const DataContainer = styled.div`
  display: flex;
  justify-content: space-between;
  font-variant-numeric: tabular-nums;
`;

// TODO: TFR-44 move to typography  group
export const BigAmount = styled(Body)`
  font-size: 1.75rem;
  font-weight: 600;
`;

// TODO: TFR-44 move to typography  group
export const SmallAmount = styled(Body)`
  font-size: 1.5rem;
  font-weight: 600;
`;

// TODO: TFR-45:Percentage make unique name or do not export
export const Percentage = styled(Body)`
  font-size: 1.3125rem;
  font-weight: normal;
`;

// TODO: TFR-45:IconWrapper make unique name or do not export
export const IconWrapper = styled.div`
  border-radius: 50%;
  font-size: 0.8331rem;
  width: 1.25rem;
  height: 1.25rem;
  margin-right: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const ArrowDownIcon = styled(FiArrowDown)``;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const ArrowUpIcon = styled(FiArrowUp)``;

// TODO: TFR-44 move to container group or do not export
export const PercentageContainer = styled.div<ComponentProps>`
  display: flex;
  align-items: center;
  ${({ $trend }) => {
    switch ($trend) {
      case 'DOWN':
        return css`
          color: ${({ theme }) => theme.colors.redMedium};
          ${IconWrapper} {
            background-color: ${({ theme }) => theme.colors.redExtraLight};
          }
        `;
      case 'UP':
      default:
        return css`
          color: ${({ theme }) => theme.colors.greenMedium};
          ${IconWrapper} {
            background-color: ${({ theme }) => theme.colors.greenExtraLight};
          }
        `;
    }
  }}
`;
